// App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AppContent from './AppContent';
import TouchDesignerRedirect from './TouchDesignerRedirect';
import Help from './Help';

function App() {
  return (
    <Routes>
      <Route path="/" element={<AppContent />} />
      <Route path="/touchdesigner" element={<TouchDesignerRedirect />} />
      <Route path="/privacypolicy" element={<AppContent />} />
      <Route path="/help" element={<Help />} />
    </Routes>
  );
}

export default App;
